import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import '../styles/Activities.css';

const iconSVGs = {
  flag: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"/>
      <line x1="4" y1="22" x2="4" y2="15"/>
    </svg>
  ),
  'chalkboard-teacher': (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="3" width="20" height="14" rx="2" ry="2"/>
      <line x1="8" y1="21" x2="16" y2="21"/>
      <line x1="12" y1="17" x2="12" y2="21"/>
    </svg>
  ),
  microscope: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="3"/>
      <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"/>
    </svg>
  ),
  'user-graduate': (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 10v6M2 10l10-5 10 5-10 5z"/>
      <path d="M6 12v5c3 3 9 3 12 0v-5"/>
    </svg>
  ),
  users: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
      <circle cx="9" cy="7" r="4"/>
      <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
      <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
    </svg>
  ),
  'pen-nib': (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17 3a2.83 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5z"/>
      <path d="M15 5l4 4"/>
    </svg>
  ),
};

const Activities = ({ lang }) => {
  const [ref, inView] = useInView({ threshold: 0.1, triggerOnce: true });

  const activities = [];
  for (let i = 1; i <= 6; i++) {
    activities.push({
      title: lang[`ACTIVITY_${i}_TITLE`] || `Activity ${i}`,
      desc: lang[`ACTIVITY_${i}_DESC`] || 'Description',
      icon: lang[`ACTIVITY_${i}_ICON`] || 'flag',
    });
  }

  return (
    <section className="activities section" id="activities" ref={ref}>
      <div className="container">
        <motion.div
          className="activities-header"
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
        >
          <div className="terminal-section-header">
                <div className="terminal-section-titlebar">
                  root@ispclub:~/# cd /ispclub/activities
                </div>
                <div className="terminal-section-body">
                  <span className="terminal-sh-line">&gt;_ sh activities.sh</span>
                </div>
              </div>
          <h2 className="section-title">{lang.ACTIVITIES_TITLE || 'What We Do'}</h2>
          <p className="section-subtitle">
            {lang.ACTIVITIES_SUBTITLE || 'Key activities of ISP Club in information security.'}
          </p>
        </motion.div>

        <div className="activities-grid">
          {activities.map((activity, index) => (
            <motion.div
              key={index}
              className="activity-card"
              initial={{ opacity: 0, y: 30 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ delay: 0.1 * index, duration: 0.5 }}
              whileHover={{ y: -8 }}
            >
              <div className="activity-icon">
                {iconSVGs[activity.icon] || iconSVGs.flag}
              </div>
              <div className="activity-index">0{index + 1}</div>
              <h3 className="activity-title">{activity.title}</h3>
              <p className="activity-desc">{activity.desc}</p>
              <div className="activity-line"></div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Activities;
